import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'

import { Box, Button, Stack } from '@mui/material'

import CheckCircle from '@mui/icons-material/CheckCircle'

import { TLGTypography } from '@components/TLGTypography'

import {
  containerSx,
  contentSx,
  getStartedForFreeButtonSx,
  heroLeftSideContentSx,
  heroSubtitleSx,
  heroTitleSx,
  overlaySx,
} from './styles'

const HeroSection = () => {
  const { t } = useTranslation()

  return (
    <Box data-testid="about-hero-section" sx={containerSx}>
      <Box sx={overlaySx} />
      <Box sx={contentSx}>
        <Stack sx={heroLeftSideContentSx}>
          <TLGTypography
            responsiveVariant={{
              xs: 'h5',
              md: 'h4',
            }}
            component="h1"
            sx={heroTitleSx}
          >
            {t(
              'Accelerate your authentic tech connections with TechnologyMatch.com, powered by The Launchpad'
            )}
          </TLGTypography>
          <TLGTypography
            responsiveVariant={{
              xs: 'subtitle1',
              md: 'h6',
            }}
            component="h2"
            sx={heroSubtitleSx}
          >
            {t(
              "We're committed to empowering you with the tools, resources, and support your need to find the perfect technology partners and solutions for your organization. Join us for free today and experience the future of tech procurement."
            )}
          </TLGTypography>

          <Button
            data-testid="hero-get-started-for-free-button"
            component={RouterLink}
            to="/signup"
            variant="contained"
            color="secondary"
            size="large"
            endIcon={<CheckCircle />}
            sx={getStartedForFreeButtonSx}
          >
            {t('Get Started for Free Now')}
          </Button>
        </Stack>
      </Box>
    </Box>
  )
}

export { HeroSection }
